export const fetchData = async (fetchFunction: (e: any) => Promise<any>, params: any = '') => {
  if (params === undefined) {
    params = null
  }
  try {
    const response = await fetchFunction(params)

    if (response.data && response.data.data) {
      return response.data.data
    } else {
      throw new Error('Respuesta de API incorrecta') // Otra acción en caso de respuesta incorrecta
    }
  } catch (error) {
    console.error('Error al obtener los datos:', error)
    return null // Otra acción o valor predeterminado en caso de error
  }
}
